interface IProps {
  titre?: string;
  titreClass?: string;
  donnee?: string | number ;
  elem?: JSX.Element;
  prefixe?: string;
  suffixe?: string;
  titreCol?:string;
  donneeCol?:string;
}

const RowDetailParenthese: React.FC<IProps> = ({
  titre,
  donnee,
  prefixe = "",
  suffixe = "",
  elem,
  titreClass,
  titreCol,
  donneeCol
}: IProps) => {
  const N = (a : any) => a === null ? "" : a;

  return (
    <div className="row">
      <div className={`col-${titreCol ? titreCol : "4"} ${titreClass ? titreClass : "pae-detail-label"}`} style={{ textAlign: 'left'}}>
        <b>{titre}</b> {elem ? (
          elem
        ) : (
          <>
            ({donnee ? N(prefixe) + donnee + N(suffixe) : "_"})
          </>
        )}
      </div>
    </div>
  )
};

export default RowDetailParenthese;
